export const apiDomain = 'https://skole.sum.ba/admin/';
export const googleAuth = apiDomain + 'login/google?redirectTo=';
export const eronetPlayer = 'https://ott.hometv.ba:11620/video/';
export const rtvHBUrl = 'https://prd-embed-eronet.spectar.tv/embed.php?id=1584823283';
export const storageUrl = apiDomain + '/storage/';
